import { APTOS_CCTP_DOMAIN_ID } from "../nonce/contracts";
import { appCctpNetwork, DECIBEL_CCTP_WRAPPER } from "./contracts";

// Turn a route on in the change that ships its v2 claim. Until then its v2 transfers stay hidden,
// because a card would offer a claim that calls the v1 contract and aborts.
// Ethereum, Arbitrum and Base, which the wallet claims with `receiveMessage`; Solana, which our
// server claims; Sui, which the wallet claims.
const WITHDRAW_DEST_DOMAINS: ReadonlySet<number> = new Set([0, 3, 5, 6, 8]);

/**
 * Whether the app can claim a v2 transfer on this route. `destDomain` is null before Circle
 * attests, when it sends no message bytes; such a transfer can't be claimed yet anyway.
 */
export function isV2ClaimSupported({
  sourceDomain,
  destDomain,
}: {
  sourceDomain: number;
  destDomain: number | null;
}): boolean {
  if (sourceDomain !== APTOS_CCTP_DOMAIN_ID) {
    // Deposits are claimed through the Decibel wrapper, so they need it published here.
    const isDeposit = destDomain === null || destDomain === APTOS_CCTP_DOMAIN_ID;
    return isDeposit && DECIBEL_CCTP_WRAPPER[appCctpNetwork()] !== null;
  }
  return destDomain === null || WITHDRAW_DEST_DOMAINS.has(destDomain);
}
